export { AuthRoute } from '@/app/routes/auth';
export { OnbaordingRoute } from '@/app/routes/onborading';
export { DeploymentRoute } from '@/app/routes/deployment';
export { DashboardRoute } from '@/app/routes/dashboard';
export { StaticRoute } from '@/app/routes/static';
export { AccountRoute } from '@/app/routes/account';
export { IntegrationRoute } from '@/app/routes/integration';
export { ObservabilityRoute } from '@/app/routes/observability';
export { OrganizationRoute } from '@/app/routes/organization';
export { KnowledgeRoute } from '@/app/routes/knowledge';
export {
  ConnectKnowledgeRoute,
  CommonConnectRoute,
  ConnectCRMRoute,
} from '@/app/routes/connect-knowledge';
export { ConnectActionRoute } from '@/app/routes/connect-action';
export { PreviewRoute } from '@/app/routes/preview';
